import { z } from 'zod';

const envSchema = z.object({
  VITE_API_ORIGIN: z.string().default('http://localhost:3001'),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_APP_VERSION: z.string().default('0.0.0'),
  VITE_FEATURE_USER_MANAGEMENT: z
    .string()
    .default('false')
    .transform((v) => v !== 'false'),
  VITE_BRAND_PREVIEW_PANEL: z.string().optional(),
  DEV: z.boolean(),
  PROD: z.boolean(),
  MODE: z.string(),
});

export type Env = z.infer<typeof envSchema>;

function initEnv(): Env {
  const parsed = envSchema.safeParse(import.meta.env);
  if (!parsed.success) {
    console.error('Invalid environment variables:', parsed.error.flatten());
    throw new Error('Environment validation failed — check VITE_* vars');
  }
  return parsed.data;
}

export const env = initEnv();
